<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { marked } from 'marked'
import impressumRaw from '../assets/impressum.md?raw'
import tosRaw from '../assets/tos.md?raw'

const props = defineProps({
    type: { type: String, default: null },
})
const emit = defineEmits(['close'])
const { t } = useI18n()

const title = computed(() => {
    if (props.type === 'impressum') return t('footer.impressum')
    if (props.type === 'tos') return t('footer.tos')
    return ''
})

const content = computed(() => {
    if (props.type === 'impressum') return marked(impressumRaw)
    if (props.type === 'tos') return marked(tosRaw)
    return ''
})
</script>

<template>
    <teleport to="body">
        <div v-if="type" class="legal-overlay" @click.self="emit('close')">
            <div class="legal-modal" role="dialog" aria-modal="true">
                <div class="legal-modal-header">
                    <strong>{{ title }}</strong>
                    <button class="legal-modal-close" data-close @click="emit('close')" aria-label="Close">&times;</button>
                </div>
                <div class="legal-modal-body" v-html="content" />
            </div>
        </div>
    </teleport>
</template>

<style scoped>
.legal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 1rem;
}
.legal-modal {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    max-width: 640px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.legal-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #e5e7eb;
    flex-shrink: 0;
}
.legal-modal-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    line-height: 1;
    color: #6b7280;
    cursor: pointer;
    padding: 0;
}
.legal-modal-close:hover { color: #111; }
.legal-modal-body {
    overflow-y: auto;
    padding: 1.25rem;
    font-size: 0.9rem;
    line-height: 1.6;
}
</style>
